import type { TVSeries, Category, FAQItem } from './types';

export const categories: Category[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'chinese', name: '国产剧', icon: 'ri-building-4-line' },
  { slug: 'korean', name: '韩剧', icon: 'ri-earth-line' },
  { slug: 'american', name: '美剧', icon: 'ri-earth-line' },
  { slug: 'japanese', name: '日剧', icon: 'ri-earth-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-line' },
];

export const tvSeriesList: TVSeries[] = [
  {
    id: 'tv-001',
    title: '繁花之下',
    subtitle: 'Bloom Beneath',
    category: 'chinese',
    region: '中国大陆',
    year: 2025,
    rating: 9.2,
    episodes: 40,
    status: '已完结',
    description: '九十年代的上海，机遇与挑战并存，讲述了一群年轻人在改革浪潮中追逐梦想、收获爱情的动人故事。',
    longDescription: '《繁花之下》是一部以九十年代上海为背景的年代情感剧。故事围绕阿宝、沪生、小毛三个年轻人展开，他们在时代巨变中闯荡商海，经历了创业的艰辛、友情的考验和爱情的美好。剧集以细腻的笔触描绘了那个充满希望与激情的年代，展现了一代人奋斗的青春史诗。全剧共40集，每一集都如同一幅精致的画卷，将老上海的风情与现代都市的活力完美融合。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20drama%20poster%20with%20a%20young%20couple%20walking%20through%20old%20Shanghai%20streets%20at%20sunset%2C%20nostalgic%201990s%20Chinese%20cityscape%20background%20with%20warm%20golden%20lights%2C%20cinematic%20photography%20style%2C%20romantic%20atmosphere%2C%20film%20grain%20texture%2C%20rich%20warm%20tones&width=600&height=800&seq=tv-cover-001&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Old%20Shanghai%20street%20scene%20in%201990s%20with%20traditional%20shikumen%20architecture%2C%20warm%20golden%20sunset%20lighting%20through%20plane%20trees%2C%20nostalgic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20film%20aesthetic%2C%20soft%20vintage%20tones%2C%20romantic%20cityscape&width=1200&height=500&seq=tv-poster-001&orientation=landscape',
    director: '王家明',
    cast: ['胡歌', '马伊琍', '唐嫣', '陈龙', '游本昌'],
    tags: ['年代剧', '爱情', '创业', '上海', '1990s'],
    updateDay: '已完结',
    views: 12800000,
    episodeList: Array.from({ length: 40 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'tv-002',
    title: '星河万里',
    subtitle: 'Galaxy Far Away',
    category: 'chinese',
    region: '中国大陆',
    year: 2026,
    rating: 8.8,
    episodes: 36,
    status: '更新中',
    description: '一位天才航天工程师与一位星空摄影师在追梦路上相遇，共同探索宇宙奥秘的科幻爱情故事。',
    longDescription: '《星河万里》是一部融合科幻与爱情元素的创新力作。故事讲述了中国航天工程师陆星辰与星空摄影师林星河在海南文昌航天发射场相遇，两人因共同的星空梦想而结缘。随着中国空间站建设、月球探测等重大航天工程的推进，他们的感情也在星辰大海中不断升华。本剧以中国航天事业为背景，展现了当代青年科技工作者的奋斗精神与家国情怀。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20sci-fi%20drama%20poster%20with%20a%20couple%20standing%20under%20a%20starry%20night%20sky%20with%20galaxy%20and%20nebula%2C%20Chinese%20space%20station%20in%20background%2C%20cinematic%20photography%2C%20dreamy%20blue%20and%20purple%20cosmic%20tones%2C%20romantic%20atmosphere&width=600&height=800&seq=tv-cover-002&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20rocket%20launch%20site%20at%20night%20with%20starry%20sky%2C%20space%20station%20silhouette%2C%20romantic%20cosmic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20deep%20blue%20and%20gold%20lighting%2C%20epic%20scale%2C%20futuristic%20vibe&width=1200&height=500&seq=tv-poster-002&orientation=landscape',
    director: '陈思成',
    cast: ['杨洋', '赵露思', '吴磊', '张子枫'],
    tags: ['科幻', '爱情', '航天', '梦想'],
    updateDay: '每周一至周五',
    views: 9600000,
    episodeList: Array.from({ length: 24 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'tv-003',
    title: '长安十二时辰之天启',
    subtitle: 'The Longest Day in Chang\'an: Apocalypse',
    category: 'chinese',
    region: '中国大陆',
    year: 2025,
    rating: 9.5,
    episodes: 48,
    status: '已完结',
    description: '盛唐长安，一场神秘天象引发惊天阴谋，不良帅张小敬再度出山，在十二时辰内拯救长安城。',
    longDescription: '《长安十二时辰之天启》是经典IP的全新续作。天宝三年上元节，长安城上空出现神秘天象，一桩离奇的命案牵出惊天阴谋。前不良帅张小敬本已归隐山林，却因故人之托再度踏入长安。十二个时辰之内，他必须揭开真相，阻止一场足以毁灭长安的阴谋。本剧在保留前作精良制作的基础上，进一步升级了场景与特效，将盛唐气象展现得淋漓尽致。',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20warrior%20in%20armor%20standing%20on%20rooftop%20overlooking%20Changan%20city%20at%20night%20with%20lanterns%2C%20historical%20drama%20poster%2C%20cinematic%20lighting%2C%20epic%20atmosphere%2C%20rich%20dark%20red%20and%20gold%20tones&width=600&height=800&seq=tv-cover-003&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Ancient%20Changan%20cityscape%20during%20Tang%20dynasty%20at%20night%20with%20thousands%20of%20red%20lanterns%2C%20busy%20market%20streets%2C%20imperial%20palace%20in%20distance%2C%20cinematic%20epic%20wide%20shot%2C%20historical%20Chinese%20architecture%2C%20dramatic%20lighting&width=1200&height=500&seq=tv-poster-003&orientation=landscape',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎', '芦芳生'],
    tags: ['古装', '悬疑', '盛唐', '动作', '历史'],
    updateDay: '已完结',
    views: 25000000,
    episodeList: Array.from({ length: 48 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'tv-004',
    title: '黑暗荣耀',
    subtitle: 'The Glory',
    category: 'korean',
    region: '韩国',
    year: 2023,
    rating: 9.1,
    episodes: 16,
    status: '已完结',
    description: '年少时遭受校园暴力的女子，精心策划了一场长达十余年的复仇计划，将所有施暴者逐一拖入深渊。',
    longDescription: '《黑暗荣耀》是韩国Netflix出品的一部复仇题材剧集，由宋慧乔主演。故事讲述女主角文东恩在高中时期遭受残酷的校园暴力后被迫退学，她花了十几年的时间精心策划复仇。她成为了施暴者女儿的班主任，从此开始实施她缜密的复仇计划。这部剧以冷峻的视角探讨了校园暴力、阶级差异和人性阴暗面，在全球范围内引起巨大反响。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20a%20woman%20in%20black%20standing%20in%20shadow%20looking%20at%20a%20luxurious%20building%2C%20dark%20revenge%20theme%2C%20cold%20winter%20atmosphere%2C%20cinematic%20photography%2C%20moody%20lighting%2C%20minimal%20composition&width=600&height=800&seq=tv-cover-004&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Dark%20winter%20Seoul%20street%20at%20night%20with%20snow%20falling%2C%20luxury%20apartment%20buildings%2C%20cold%20blue%20and%20grey%20tones%2C%20cinematic%20Korean%20drama%20aesthetic%2C%20lonely%20atmosphere%2C%20street%20lamps%20glowing&width=1200&height=500&seq=tv-poster-004&orientation=landscape',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '朴成勋', '郑成日'],
    tags: ['复仇', '校园暴力', '悬疑', '人性'],
    updateDay: '已完结',
    views: 32000000,
    episodeList: Array.from({ length: 16 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '50分钟',
    })),
  },
  {
    id: 'tv-005',
    title: '机智的医生生活',
    subtitle: 'Hospital Playlist',
    category: 'korean',
    region: '韩国',
    year: 2024,
    rating: 9.4,
    episodes: 24,
    status: '已完结',
    description: '五位从医学院时期就是好友的医生，在同一家医院工作，讲述了他们平凡而温暖的日常与医患故事。',
    longDescription: '《机智的医生生活》第三季延续了前两季温暖治愈的风格。五位年过四十的医生好友——李翼俊、安涏援、金隽婠、杨硕亨和蔡颂和，继续在律帝医院谱写属于他们的故事。他们在手术室救死扶伤，在乐队排练室释放压力，在彼此的生命中相互依靠。本季聚焦于医生们在后疫情时代面临的新的挑战与抉择，以及他们各自感情生活的新篇章。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20medical%20drama%20poster%20with%20five%20doctors%20in%20white%20coats%20smiling%20together%2C%20warm%20hospital%20background%2C%20friendly%20atmosphere%2C%20bright%20natural%20lighting%2C%20healing%20vibe%2C%20professional%20yet%20cozy%20visual%20style&width=600&height=800&seq=tv-cover-005&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Bright%20modern%20hospital%20corridor%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20doctors%20walking%20and%20chatting%2C%20Korean%20drama%20aesthetic%2C%20healing%20atmosphere%2C%20clean%20white%20and%20green%20tones%2C%20cinematic%20shot&width=1200&height=500&seq=tv-poster-005&orientation=landscape',
    director: '申元浩',
    cast: ['曹政奭', '柳演锡', '郑敬淏', '金大明', '田美都'],
    tags: ['医疗', '友情', '治愈', '音乐'],
    updateDay: '已完结',
    views: 18000000,
    episodeList: Array.from({ length: 24 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '60分钟',
    })),
  },
  {
    id: 'tv-006',
    title: '最后的生还者',
    subtitle: 'The Last of Us',
    category: 'american',
    region: '美国',
    year: 2025,
    rating: 9.3,
    episodes: 10,
    status: '更新中',
    description: '末日世界中，一个硬汉走私者受托护送一名14岁女孩穿越被真菌感染摧毁的美国。',
    longDescription: '《最后的生还者》第二季延续了第一季的高水准制作。故事紧接第一季结尾，乔尔和艾莉在杰克逊定居下来，但平静的生活并没有持续太久。新的威胁、旧日的恩怨、以及艾莉对真相的追寻，将两人再次推入险境。本季引入新角色艾比，三条故事线交织推进，探讨了复仇与救赎的永恒主题。HBO出品，制作精良程度堪比电影。',
    coverImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20drama%20poster%20with%20a%20man%20and%20teenage%20girl%20walking%20through%20ruined%20city%20covered%20in%20vegetation%2C%20survival%20theme%2C%20cinematic%20photography%2C%20moody%20green%20and%20brown%20tones%2C%20hopeful%20yet%20dark%20atmosphere&width=600&height=800&seq=tv-cover-006&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20abandoned%20city%20overgrown%20with%20plants%20and%20moss%2C%20crumbling%20skyscrapers%20in%20distance%2C%20soft%20morning%20light%20through%20fog%2C%20cinematic%20wide%20shot%2C%20nature%20reclaiming%20civilization%2C%20beautiful%20decay&width=1200&height=500&seq=tv-poster-006&orientation=landscape',
    director: '克雷格·麦辛',
    cast: ['佩德罗·帕斯卡', '贝拉·拉姆齐', '凯特琳·德弗', '伊莎贝拉·默塞德'],
    tags: ['末日', '冒险', '生存', '游戏改编', 'HBO'],
    updateDay: '每周一',
    views: 45000000,
    episodeList: Array.from({ length: 6 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '55分钟',
    })),
  },
  {
    id: 'tv-007',
    title: '异星灾变',
    subtitle: 'Raised by Wolves',
    category: 'american',
    region: '美国',
    year: 2025,
    rating: 8.6,
    episodes: 12,
    status: '已完结',
    description: '两个机器人在一个神秘的原始星球上抚养人类孩子，但随着宗教殖民者的到来，和平被打破。',
    longDescription: '《异星灾变》第三季是雷德利·斯科特监制的科幻巨制的最终章。开普勒22b星球的秘密终于被揭开，母亲和父亲带领着孩子们在与索尔教派的对抗中，逐渐发现了这颗星球远古文明的真相。本季深入探讨了人工智能、信仰与人性之间的关系，视觉效果震撼，哲学思辨深刻，是一部不可多得的硬科幻佳作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20drama%20poster%20with%20a%20humanoid%20android%20standing%20on%20alien%20planet%20with%20strange%20rock%20formations%2C%20distant%20stars%2C%20minimalist%20design%2C%20cinematic%20photography%2C%20cold%20silver%20and%20dark%20tones%2C%20mysterious%20atmosphere&width=600&height=800&seq=tv-cover-007&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Alien%20planet%20landscape%20with%20strange%20geometric%20rock%20formations%20and%20purple%20sky%2C%20two%20suns%20setting%2C%20barren%20but%20beautiful%20terrain%2C%20cinematic%20wide%20shot%2C%20sci-fi%20epic%20scale%2C%20atmospheric%20haze&width=1200&height=500&seq=tv-poster-007&orientation=landscape',
    director: '雷德利·斯科特',
    cast: ['阿曼达·科林', '阿布巴卡尔·萨利姆', '崔维斯·费米尔'],
    tags: ['科幻', 'AI', '宗教', '太空'],
    updateDay: '已完结',
    views: 8900000,
    episodeList: Array.from({ length: 12 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '50分钟',
    })),
  },
  {
    id: 'tv-008',
    title: '重启人生',
    subtitle: 'Brush Up Life',
    category: 'japanese',
    region: '日本',
    year: 2024,
    rating: 9.0,
    episodes: 10,
    status: '已完结',
    description: '一名普通女性意外去世后获得重启人生的机会，为了来世能投胎为人，她不断积攒阴德重活人生。',
    longDescription: '《重启人生》是一部脑洞大开的奇幻喜剧。33岁的近藤麻美是一名普通的公务员，在一次意外中去世后来到了死后的世界。被告知来世将成为危地马拉的食蚁兽，为了能投胎为人，她选择重启人生，从小开始积攒阴德。然而她发现，人生的选择远比想象中复杂。每一轮人生都充满了意想不到的笑料和感动，让人在捧腹之余也思考人生的真谛。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20poster%20with%20a%20young%20woman%20looking%20at%20multiple%20reflections%20of%20herself%20in%20different%20outfits%2C%20whimsical%20fantasy%20theme%2C%20bright%20pastel%20colors%2C%20playful%20Japanese%20aesthetic%2C%20light%20and%20fun%20atmosphere&width=600&height=800&seq=tv-cover-008&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Quiet%20Japanese%20suburban%20town%20with%20cherry%20blossoms%2C%20small%20shops%20and%20houses%2C%20warm%20spring%20sunlight%2C%20peaceful%20everyday%20life%20scene%2C%20Japanese%20drama%20aesthetic%2C%20soft%20natural%20colors%2C%20cinematic%20composition&width=1200&height=500&seq=tv-poster-008&orientation=landscape',
    director: '水野格',
    cast: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李', '染谷将太'],
    tags: ['奇幻', '喜剧', '人生', '治愈'],
    updateDay: '已完结',
    views: 7500000,
    episodeList: Array.from({ length: 10 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'tv-009',
    title: '舞伎家的料理人',
    subtitle: 'The Makanai: Cooking for the Maiko House',
    category: 'japanese',
    region: '日本',
    year: 2024,
    rating: 8.7,
    episodes: 9,
    status: '已完结',
    description: '两个女孩从青森来到京都，一个成为舞伎，一个成为料理人，在祇园的花街中互相扶持成长。',
    longDescription: '《舞伎家的料理人》是是枝裕和导演的首部Netflix日剧，改编自小山爱子的同名漫画。故事背景设在京都祇园的花街，来自青森的季代和堇从小就是形影不离的好友。堇立志成为一流的舞伎，而季代则成为了舞伎家的料理人。通过一道道温暖的料理，季代治愈着舞伎们的身体和心灵。是枝裕和用他一贯的温柔镜头，捕捉了京都四季流转中的美好日常。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20poster%20with%20two%20young%20women%20in%20kimono%20in%20traditional%20Kyoto%20house%2C%20one%20cooking%20in%20kitchen%2C%20warm%20steam%20rising%2C%20tatami%20room%2C%20gentle%20lighting%2C%20healing%20Japanese%20aesthetic&width=600&height=800&seq=tv-cover-009&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Traditional%20Kyoto%20machiya%20townhouse%20with%20sliding%20doors%20and%20small%20garden%2C%20cherry%20blossom%20petals%20falling%2C%20warm%20interior%20light%20spilling%20out%2C%20Gion%20district%20atmosphere%2C%20cinematic%20Japanese%20aesthetic%2C%20peaceful%20evening&width=1200&height=500&seq=tv-poster-009&orientation=landscape',
    director: '是枝裕和',
    cast: ['森七菜', '出口夏希', '莳田彩珠', '桥本爱', '松坂庆子'],
    tags: ['美食', '友情', '京都', '成长'],
    updateDay: '已完结',
    views: 6200000,
    episodeList: Array.from({ length: 9 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '40分钟',
    })),
  },
  {
    id: 'tv-010',
    title: '歌手2025',
    subtitle: 'Singer 2025',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    rating: 8.3,
    episodes: 13,
    status: '更新中',
    description: '顶级歌手同台竞技的巅峰音乐盛宴，每期六位实力唱将轮番登台，由现场观众投票决定去留。',
    longDescription: '《歌手2025》是湖南卫视推出的顶级音乐竞技节目第十二季。本季赛制全面升级，引入"踢馆挑战"和"帮帮唱"全新环节，同时邀请国际顶级歌手加盟，打造真正的国际级音乐舞台。参赛歌手涵盖流行、摇滚、民谣、R&B等多种风格，每一场竞演都是一次视听盛宴。节目由何炅主持，音乐总监梁翘柏坐镇，确保了每一期的音乐品质。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20with%20a%20singer%20on%20grand%20stage%20with%20dramatic%20spotlight%2C%20microphone%20in%20hand%2C%20concert%20atmosphere%2C%20golden%20and%20dark%20tones%2C%20cinematic%20lighting%2C%20grand%20scale&width=600&height=800&seq=tv-cover-010&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20lighting%20and%20LED%20screens%2C%20massive%20audience%20with%20light%20sticks%2C%20epic%20music%20show%20atmosphere%2C%20golden%20spotlights%2C%20cinematic%20wide%20shot%2C%20arena%20scale%2C%20energetic%20vibe&width=1200&height=500&seq=tv-poster-010&orientation=landscape',
    director: '洪涛',
    cast: ['那英', '周深', '华晨宇', '邓紫棋', '林俊杰', '李荣浩'],
    tags: ['音乐', '竞技', '综艺', '直播'],
    updateDay: '每周五',
    views: 35000000,
    episodeList: Array.from({ length: 8 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}期`,
      duration: '90分钟',
    })),
  },
  {
    id: 'tv-011',
    title: '向往的生活',
    subtitle: 'Back to Field',
    category: 'variety',
    region: '中国大陆',
    year: 2025,
    rating: 8.6,
    episodes: 14,
    status: '更新中',
    description: '主持人和嘉宾们远离城市喧嚣，在田园中自给自足，享受慢生活的治愈系综艺。',
    longDescription: '《向往的生活》第八季来到了云南大理的苍山洱海之间。黄磊、何炅、张艺兴、彭昱畅、张子枫五位常驻主持人在洱海边的一座白族小院中，过着自给自足的田园生活。每一期都有不同的飞行嘉宾到访，大家一起劳作、做饭、聊天、唱歌，在简单的生活中寻找内心的平静。本季特别增加了非遗文化体验环节，让观众在享受田园之美的同时，也能感受到传统文化的魅力。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20five%20people%20sitting%20around%20a%20wooden%20table%20in%20a%20rustic%20courtyard%2C%20laughing%20and%20eating%2C%20countryside%20background%2C%20warm%20sunset%20light%2C%20healing%20pastoral%20atmosphere%2C%20natural%20colors&width=600&height=800&seq=tv-cover-011&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Dali%20Erhai%20Lake%20with%20Cangshan%20mountains%20in%20background%2C%20traditional%20Bai%20ethnic%20courtyard%20house%20by%20the%20lake%2C%20golden%20sunset%20light%2C%20peaceful%20pastoral%20scene%2C%20cinematic%20wide%20shot%2C%20idyllic%20Yunnan%20landscape&width=1200&height=500&seq=tv-poster-011&orientation=landscape',
    director: '王征宇',
    cast: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    tags: ['慢综艺', '美食', '田园', '治愈'],
    updateDay: '每周六',
    views: 22000000,
    episodeList: Array.from({ length: 6 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}期`,
      duration: '80分钟',
    })),
  },
  {
    id: 'tv-012',
    title: '灵笼：终章',
    subtitle: 'Ling Cage: Final Chapter',
    category: 'anime',
    region: '中国大陆',
    year: 2025,
    rating: 9.6,
    episodes: 12,
    status: '更新中',
    description: '末日废土世界中，人类在浮空堡垒灯塔上艰难求生，地面上的未知生物噬极兽时刻威胁着他们。',
    longDescription: '《灵笼：终章》是国产科幻动画的巅峰之作的最终篇章。故事发生在末日后的地球，幸存的人类居住在悬浮于天空的堡垒"灯塔"中。猎荒者小队不断前往地面采集资源，同时与强大的噬极兽战斗。终章将揭示灯塔的终极秘密、玛娜生态的真相，以及马克与冉冰的最终命运。本作以顶级的3D动画制作、宏大的世界观和深刻的哲学思考，被观众誉为"国产动画天花板"。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20with%20a%20warrior%20in%20power%20armor%20facing%20a%20giant%20monster%20in%20post%20apocalyptic%20wasteland%2C%20floating%20fortress%20in%20sky%2C%20epic%20dark%20theme%2C%20cinematic%20lighting%2C%20sci-fi%20atmosphere&width=600&height=800&seq=tv-cover-012&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20wasteland%20with%20a%20massive%20floating%20circular%20fortress%20in%20stormy%20sky%2C%20ruined%20city%20below%2C%20lightning%20strikes%2C%20dark%20epic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20sci-fi%20anime%20style%2C%20dramatic%20lighting&width=1200&height=500&seq=tv-poster-012&orientation=landscape',
    director: '董相博',
    cast: ['黄莺', '李元韬', '陶典', '程玉珠', '夏磊'],
    tags: ['科幻', '末日', '3D动画', '国产', '机甲'],
    updateDay: '每周六',
    views: 15000000,
    episodeList: Array.from({ length: 8 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '30分钟',
    })),
  },
  {
    id: 'tv-013',
    title: '时光代理人',
    subtitle: 'Link Click',
    category: 'anime',
    region: '中国大陆',
    year: 2025,
    rating: 9.3,
    episodes: 12,
    status: '已完结',
    description: '两个拥有特殊能力的青年经营着一家时光照相馆，通过照片进入过去，帮客户完成未了心愿。',
    longDescription: '《时光代理人》第三季延续了前两季的高口碑。程小时和陆光继续经营着"时光照相馆"，通过照片进入过去为客户完成委托。本季的故事线更加复杂，引入了多个时间线交织的叙事结构。每一个委托背后都藏着一个感人至深的故事，而程小时和陆光自身的命运也在这时光穿梭中逐渐揭开。本作以精彩的悬疑叙事和深刻的情感表达，被誉为国产2D动画的标杆之作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20two%20young%20men%20in%20a%20vintage%20photo%20studio%2C%20one%20holding%20a%20camera%2C%20clock%20motif%20in%20background%2C%20time%20travel%20theme%2C%20warm%20nostalgic%20lighting%2C%20mysterious%20atmosphere&width=600&height=800&seq=tv-cover-013&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Vintage%20photo%20studio%20interior%20with%20old%20cameras%20and%20photographs%20hanging%2C%20warm%20afternoon%20sunlight%20through%20windows%2C%20nostalgic%20atmosphere%2C%20clocks%20on%20walls%2C%20Chinese%20anime%20aesthetic%2C%20cinematic%20composition&width=1200&height=500&seq=tv-poster-013&orientation=landscape',
    director: '李豪凌',
    cast: ['杨天翔', '苏尚卿', '李诗萌', '赵熠彤'],
    tags: ['悬疑', '时间旅行', '治愈', '2D动画'],
    updateDay: '已完结',
    views: 11000000,
    episodeList: Array.from({ length: 12 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '25分钟',
    })),
  },
  {
    id: 'tv-014',
    title: '庆余年之风起',
    subtitle: 'Joy of Life: Wind Rising',
    category: 'chinese',
    region: '中国大陆',
    year: 2026,
    rating: 9.0,
    episodes: 36,
    status: '更新中',
    description: '范闲在庆国朝堂之上步步为营，一场席卷天下的风暴正在酝酿，他能否在乱世中守护所爱之人？',
    longDescription: '《庆余年之风起》是《庆余年》系列的第三季。故事紧接第二季结尾，范闲在北齐经历了生死考验后回到庆国，却发现朝堂局势更加波谲云诡。二皇子、太子、长公主各方势力暗流涌动，而北齐的威胁也日益逼近。范闲必须在权力的漩涡中找到自己的立足之地，同时保护身边的人。本季将揭晓叶轻眉之死的真相，以及范闲的身世之谜。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20a%20man%20in%20elegant%20ancient%20robe%20holding%20a%20sword%2C%20palace%20in%20background%2C%20dramatic%20wind%20effect%2C%20epic%20atmosphere%2C%20rich%20dark%20red%20and%20gold%20tones%2C%20cinematic%20photography&width=600&height=800&seq=tv-cover-014&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%20at%20sunset%20with%20red%20pillars%20and%20golden%20roofs%2C%20dramatic%20clouds%20in%20sky%2C%20epic%20historical%20drama%20scene%2C%20cinematic%20wide%20shot%2C%20grand%20scale%2C%20rich%20colors&width=1200&height=500&seq=tv-poster-014&orientation=landscape',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '辛芷蕾', '郭麒麟'],
    tags: ['古装', '权谋', '武侠', '改编'],
    updateDay: '每周一至周三',
    views: 42000000,
    episodeList: Array.from({ length: 20 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '45分钟',
    })),
  },
  {
    id: 'tv-015',
    title: '她和她的她',
    subtitle: 'Shards of Her',
    category: 'korean',
    region: '韩国',
    year: 2024,
    rating: 8.9,
    episodes: 9,
    status: '已完结',
    description: '一名职场女强人在遭遇车祸后，发现自己被困在两个平行世界之间，一桩尘封的命案也逐渐浮出水面。',
    longDescription: '《她和她的她》是一部心理悬疑剧。女主角林晨曦是一名成功的猎头顾问，在一场车祸后，她发现自己不断在两个世界中切换——一个世界里她是成功的职场女性，另一个世界里她是一名普通的中学教师。两个世界都发生了命案，而死者和凶手似乎有关联。随着调查深入，一桩十年前的旧案逐渐浮出水面，真相远比她想象的更加残酷。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20psychological%20thriller%20poster%20with%20a%20womans%20face%20split%20in%20two%2C%20one%20half%20professional%20suit%20one%20half%20casual%2C%20mirror%20reflection%20concept%2C%20dark%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20photography&width=600&height=800&seq=tv-cover-015&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Split%20screen%20showing%20modern%20Seoul%20skyscraper%20office%20on%20left%20and%20quiet%20suburban%20school%20on%20right%2C%20rainy%20day%2C%20moody%20blue%20tones%2C%20psychological%20thriller%20aesthetic%2C%20Korean%20drama%20style%2C%20cinematic%20composition&width=1200&height=500&seq=tv-poster-015&orientation=landscape',
    director: '金哲圭',
    cast: ['金泰梨', '南柱赫', '金惠允', '崔宇植'],
    tags: ['悬疑', '心理', '平行世界', '犯罪'],
    updateDay: '已完结',
    views: 9800000,
    episodeList: Array.from({ length: 9 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '50分钟',
    })),
  },
  {
    id: 'tv-016',
    title: '一人之下',
    subtitle: 'The Outcast',
    category: 'anime',
    region: '中国大陆',
    year: 2025,
    rating: 9.1,
    episodes: 24,
    status: '更新中',
    description: '普通大学生张楚岚因爷爷的坟墓被盗，意外卷入异人世界，从此开启了一段波澜壮阔的冒险。',
    longDescription: '《一人之下》第五季延续了漫画的高人气。张楚岚在罗天大醮之后，与冯宝宝一起前往碧游村调查马仙洪的秘密。本季深入展现了异人世界的庞大世界观，八奇技的起源逐渐浮出水面。张楚岚作为"不摇碧莲"的成长之路，以及冯宝宝身世之谜的逐步揭晓，让观众欲罢不能。本季的战斗场面全面升级，动画制作水准达到新高度。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20a%20young%20man%20using%20supernatural%20golden%20energy%20attack%2C%20martial%20arts%20pose%2C%20traditional%20Chinese%20elements%2C%20dynamic%20action%20scene%2C%20bright%20golden%20and%20red%20effects%2C%20epic%20atmosphere&width=600&height=800&seq=tv-cover-016&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20village%20hidden%20in%20mountains%20with%20mist%2C%20martial%20arts%20training%20ground%2C%20supernatural%20energy%20glowing%2C%20epic%20fantasy%20scene%2C%20Chinese%20anime%20aesthetic%2C%20cinematic%20wide%20shot&width=1200&height=500&seq=tv-poster-016&orientation=landscape',
    director: '王昕',
    cast: ['夏侯落枫', '小连杀', '藤新', '图特哈蒙', '宝木中阳'],
    tags: ['热血', '异能', '国产', '漫画改编'],
    updateDay: '每周五',
    views: 13000000,
    episodeList: Array.from({ length: 14 }, (_, i) => ({
      ep: i + 1,
      title: `第${i + 1}集`,
      duration: '24分钟',
    })),
  },
];

export const faqList: FAQItem[] = [
  {
    question: '小草影院的电视剧资源多久更新一次？',
    answer: '小草影院的电视剧资源实行每日更新制度。热播剧集一般在播出后2-4小时内即可上线，确保您能够在第一时间追到最新剧集。国产剧、韩剧、美剧、日剧等不同类型的剧集均有专门的更新团队负责跟进，保证更新的及时性和稳定性。',
  },
  {
    question: '在小草影院观看电视剧需要付费吗？',
    answer: '小草影院目前对所有用户提供完全免费的电视剧在线观看服务。您无需注册账号，无需支付任何费用，即可享受高清画质的追剧体验。我们通过广告收入来维持网站的运营，为您提供持续稳定的免费服务。',
  },
  {
    question: '为什么有些剧集播放时会卡顿？如何解决？',
    answer: '播放卡顿通常与您的网络环境有关。我们建议您：1）检查网络连接是否稳定；2）尝试切换到较低清晰度；3）暂停播放等待缓冲完成后再观看；4）避开晚间高峰时段观看。小草影院的服务器部署了CDN加速，大多数情况下都能提供流畅的播放体验。',
  },
  {
    question: '小草影院支持哪些设备观看？',
    answer: '小草影院全面支持PC端（Windows/Mac）、移动端（iOS/Android手机和平板）、智能电视和电视盒子等多种设备。我们的网站采用响应式设计，能够自动适配不同屏幕尺寸，让您随时随地畅享追剧乐趣。建议使用Chrome、Safari、Edge等主流浏览器获得最佳体验。',
  },
  {
    question: '如何在小草影院找到想看的电视剧？',
    answer: '您可以通过以下方式快速找到想看的电视剧：1）使用首页顶部的搜索框直接搜索剧名或演员名；2）通过分类导航浏览不同地区或类型的电视剧；3）查看首页的"热门推荐"和"最新更新"板块发现热门剧集；4）浏览分类页面，按国产剧、韩剧、美剧、日剧等类型筛选。',
  },
  {
    question: '小草影院的画质如何？支持高清吗？',
    answer: '小草影院提供多种画质选择，包括标清、高清（720P）、超清（1080P）等，部分热门剧集还支持4K超高清画质。您可以在播放器右下角的设置中自由切换画质选项。我们建议在网络条件良好的情况下选择高清或超清模式，以获得最佳的观影体验。',
  },
  {
    question: '小草影院有手机App吗？',
    answer: '目前小草影院暂未推出独立的手机App，但您可以通过手机浏览器直接访问我们的网站，网站已针对移动端进行了深度优化，提供与App同样流畅的使用体验。您可以将网站添加到手机桌面，方便快速访问。未来我们将根据用户需求考虑推出App版本。',
  },
];

export const aboutData = {
  brandName: '小草影院',
  slogan: '小草虽小，视界无限',
  founded: '2018年',
  userCount: '5000万+',
  contentCount: '10万+',
  dailyUpdate: '200+',
  introduction: '小草影院成立于2018年，是国内领先的在线影视内容聚合平台。我们以"小草虽小，视界无限"为品牌理念，致力于为广大影视爱好者提供最新、最全、最流畅的电视剧在线观看服务。经过多年的发展，小草影院已经积累了超过5000万的忠实用户，收录了超过10万部影视作品，每日更新超过200集最新剧集内容。',
  story: '小草影院的创始团队源自一群热爱影视的年轻人。2018年，他们发现很多追剧爱好者常常因为找不到高清资源、播放卡顿、更新不及时等问题而苦恼。带着"让每个人都能轻松追剧"的初心，他们创办了小草影院。从最初的几个人、几十部剧集，到如今拥有专业的内容运营团队、技术团队和客服团队，小草影院始终坚持用户至上的原则，不断优化产品体验，丰富内容资源。如同小草一般，虽不起眼，却拥有顽强的生命力和无限的可能。',
  values: [
    { title: '内容丰富', description: '涵盖国产剧、韩剧、美剧、日剧、综艺、动漫等全品类影视内容，满足不同用户的口味需求。' },
    { title: '极速更新', description: '专业内容团队全天候跟进，热播剧集播出后最快2小时内更新上线，让追剧不再等待。' },
    { title: '流畅体验', description: '采用先进的CDN加速技术和自适应码率方案，确保在不同网络环境下都能流畅播放。' },
    { title: '完全免费', description: '坚持免费服务模式，用户无需付费即可享受高清观影体验，让好内容触手可及。' },
  ],
  testimonials: [
    { user: '追剧达人小王', rating: 5, comment: '小草影院真的是我每天必逛的网站！更新速度超级快，画质也很好，关键是免费！推荐给所有爱追剧的朋友！' },
    { user: '影视爱好者小李', rating: 5, comment: '用了三年多了，资源越来越丰富，从国产剧到韩剧美剧日剧应有尽有。分类也很清晰，找剧特别方便。' },
    { user: '宅家追剧人小张', rating: 5, comment: '之前用过的追剧网站不是卡就是广告多，小草影院的体验真的好太多了。流畅不卡顿，追剧体验一级棒！' },
    { user: '深夜追剧党小陈', rating: 5, comment: '深夜档的剧更新也很快，有时候刚播完没多久就上线了。作为夜猫子真的太感动了，五星好评！' },
    { user: '韩剧迷小刘', rating: 4.5, comment: '韩剧资源特别全！最新的韩剧基本上都能第一时间看到，翻译质量也很不错，韩剧爱好者的天堂！' },
    { user: '全职妈妈小周', rating: 5, comment: '带娃之余追剧是我最大的放松方式。小草影院界面简洁好用，手机上看也很方便，陪伴我度过了无数个带娃的夜晚。' },
  ],
  contact: {
    email: 'contact@xiaocaoyingyuan.com',
    wechat: '小草影院官方',
    weibo: '@小草影院官方微博',
    address: '北京市朝阳区望京科技园区小草大厦',
  },
};